import { CheckIcon, CloseIcon } from "@chakra-ui/icons";
import { Toast } from "components/toast";
import { api3cPlus } from "api/wss-c3plus";
import { openModalConfirm } from "components/modal-confirm-new";
import { Controls3cPlusActions } from "contexts/types/context-3cplus-types";
import { current3cplusControls } from "contexts/Context3cPlus";
import { Dispatch } from "react";
// UA type is handled inside jssip-manager
import { stompManager } from "./stomp-manager";

export interface QualificationProps {
  allow_schedule: null;
  allow_schedule_to_another_number: null;
  behavior: 2;
  color: string;
  conversion: false;
  days_limit: null;
  emoji: null;
  id: number;
  name: string;
  readable_behavior: "not-call-identifier";
  should_insert_blacklist: boolean;
}

interface AuthenticatedUser3CPlus {
  id: number;
  name: string;
  email: string;
  active: number;
  api_token: string;
  confirmed: number;
  confirmation_code: null;
  extension_password: string;
  telephony_id: string;
  webphone: boolean;
  user_document: string;
  extension: {
    id: number;
    extension_number: number;
    type: string;
  };
  role: {
    id: number;
    name: string;
    readable_name: string;
  };
  settings: {
    id: number;
    timezone: string;
    language: string;
    date_format: string;
    hour_format: string;
    web_extension: boolean;
  };
  teams: null;
  campaigns: null;
  company: {
    id: number;
    name: string;
    currency: string;
    balance: number;
    domain: string;
    logo_name: string;
    logo_image_link: string;
    socket_channel: string;
    users: null;
  };
  receptive_queues: null;
}

export const get3CplusAuthenticatedUser = async () => {
  const { data } = await api3cPlus.get<AuthenticatedUser3CPlus>(`/3cplus/me`);
  return data;
};

export const enterCampaign = async (campaign: number, mode: string) => {
  const { data } = await api3cPlus.post(`/3cplus/agent/login`, {
    campaign,
    mode,
  });
  return data;
};

export const logoutCampaign = async () => {
  try {
    const { data } = await api3cPlus.post(`/3cplus/agent/logout`, {});
    return data;
  } catch (e) {}
};

export const getQualifications = async () => {
  const { data }: { data: QualificationProps[] } = await api3cPlus.get(
    `/3cplus/qualification-lists/agent/qualifications`
  );
  return data;
};

export const listCampaigns = async () => {
  const { data } = await api3cPlus.get(`/3cplus/campaigns`);
  return data;
};

export const enterManualMode = async () => {
  const { isManualMode } = current3cplusControls;
  if (!isManualMode) {
    try {
      const { data } = await api3cPlus.post("/3cplus/agent/manual_call/enter");
      return data;
    } catch (e) {
      const { data } = await api3cPlus.post(
        `/3cplus/agent/manual_call_acw/enter`
      );
      return data;
    }
  }
};

export const exitManualCallState = async ({
  dispatch3cPlus,
}: {
  dispatch3cPlus: Dispatch<Controls3cPlusActions>;
}) => {
  const { data } = await api3cPlus.post(`/3cplus/agent/manual_call/exit`);
  dispatch3cPlus({ type: "notInManualMode" });
  return data;
};

export const manualCall = async (phone: string) => {
  const { data } = await api3cPlus.post(`/3cplus/agent/manual_call/dial`, {
    phone,
  });
  return data;
};

export const makeManualCall = async ({
  phone,
  dispatch3cPlus,
}: {
  phone: string;
  dispatch3cPlus: Dispatch<Controls3cPlusActions>;
}) => {
  if (phone.startsWith("55")) phone = phone.replace("55", "");
  try {
    await enterManualMode();
    dispatch3cPlus({ type: "inManualMode" });
  } catch (e) {}
  await manualCall(phone);
};

export const desligarChamada3cPlus = async ({
  dispatch3cPlus,
  idCall,
}: {
  idCall: number;
  dispatch3cPlus: Dispatch<Controls3cPlusActions>;
}) => {
  try {
    await api3cPlus.post(`3cplus/agent/call/${idCall}/hangup`);
    if (
      window.location.pathname === "/atendimentos" &&
      current3cplusControls.isManualMode
    ) {
      openModalReturnToCampaign({ dispatch3cPlus });
    }
    if (
      window.location.pathname !== "/atendimento-cliente-page" &&
      current3cplusControls.isManualMode
    ) {
      dispatch3cPlus({ type: "clearIdCall" });
    }
    // dispatch3cPlus({ type: "notHangingUpCall" });
  } catch (e: any) {
    const errorMessage = e?.response?.data?.detail;
    Toast({
      title: errorMessage ?? "Erro ao desligar chamada",
    });
  } finally {
  }
};

export function disconnect3cPlusStomp() {
  stompManager.disconnect();
}

// Modal
export const openModalReturnToCampaign = ({
  dispatch3cPlus,
}: {
  dispatch3cPlus: Dispatch<Controls3cPlusActions>;
}) => {
  openModalConfirm({
    message: "Deseja voltar para campanha?",
    onConfirm: async () => await exitManualCallState({ dispatch3cPlus }),
    confirmButtonStyle: { variant: undefined, leftIcon: <CheckIcon /> },
    rejectButtonStyle: { leftIcon: <CloseIcon w="12px" h="12px" /> },
  });
};
